import { createSlice } from '@reduxjs/toolkit';
import { clearStoredToken } from '../../services/user-storage';



const initialState = {
  token: null,
  user: null,
  currentLang: 'en',
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setCurrentLang: (state, action) => {
      state.currentLang = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
      state.token = null;
      state.darkMode = false;
      state.currentLang = 'en';
      clearStoredToken()
    },
  },
});


export const { setUser, setToken, clearUser, setCurrentLang } =
  userSlice.actions;

export default userSlice.reducer;


